<template>
  <div id="wrap-document-clip">

    <div v-if="!busy">

      <loading :active.sync="busy"/>
      
      <section id="header-document-clip">

        <div id="header-wrap">
          <div id="title-document-clip">{{ $t("header.document_clip") }}</div>
          <div v-if="!expired">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn id="btn-add-documents" v-on="on"
                  x-small fab depressed dark color="#536bff"
                  @click="showAddDocuments()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('doc_list.add_documents') }}</span>
            </v-tooltip>
          </div>
        </div>

        <div v-show="!!sorted_docs.length">
          <v-text-field
            v-model="search_keyword"
            hide-details
            solo flat
            background-color="grey lighten-5"
            clearable
            single-line
            append-icon="mdi-magnify"
            placeholder="search...">
          </v-text-field>
        </div>

      </section>

      <section id="content-toolbar" v-show="!!sorted_docs.length">

        <div id="toolbar-left" v-if="!checked_docs.length">
          <div v-show="!!visible_docs.length">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn small icon color="#c1c3c9">
                    <v-icon small>mdi-sort-descending</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list dense>
                <v-list-item @click="sort_by=0">
                  {{ $t('sorting.visited_date_a') }}
                  <v-icon v-if="sort_by==0" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=1">
                  {{ $t('sorting.title_a') }}
                  <v-icon v-if="sort_by==1" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=2">
                  {{ $t('sorting.title_d') }}
                  <v-icon v-if="sort_by==2" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=3">
                  {{ $t('sorting.created_date_a') }}
                  <v-icon v-if="sort_by==3" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=4">
                  {{ $t('sorting.created_date_d') }}
                  <v-icon v-if="sort_by==4" color="green" small>mdi-check</v-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div id="toolbar-left" v-else>
          <div v-if="!!visible_docs.length">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon color="#c1c3c9" v-on="on"
                  @click.stop="temp_keys=checked_docs;copyDocuments()">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("document_clip.copy_move_to_projects") }}</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon color="#c1c3c9" v-on="on"
                  @click="temp_keys=checked_docs;remove_dialog=true">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("document_clip.remove_from_document_clip") }}</span>
            </v-tooltip>
          </div>
        </div>

        <div id="toolbar-right">
          <div>
            <span v-if="!!num_docs">{{ index_page * num_docs_page + 1 }}</span>
            <span v-else>0</span>
            <span>-</span>
            <span v-if="(index_page + 1) * num_docs_page>num_docs">{{ num_docs }}</span>
            <span v-else>{{ (index_page + 1) * num_docs_page }}</span>
            <span>/</span>
            <span>{{ num_docs }}</span>
          </div>
          <div v-if="num_pages>1">
            <v-btn icon small @click="index_page-=1" :disabled="index_page==0">
              <v-icon color="#bac2cc">mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon small @click="index_page+=1" :disabled="index_page+1==num_pages">
              <v-icon color="#bac2cc">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </section>

      <section v-if="expired">
        <div class="expired-contents-meta">
          <span class="word-break">언제 어디서나 관심있는 자료를 발견하면 도큐먼트 클립을 이용해보세요.</span>
          <span class="word-break">클립에 모아둔 자료는 언제나 회원님의 프로젝트에 추가할 수 있습니다.</span>
        </div>
        <div class="expired-contents-meta">
           도큐먼트 클립은 <b>프리미엄 회원</b>에게 제공됩니다.
        </div>
        <div class="expired-contents-btn">
          <v-btn depressed dark color="#ff5193"
            :to="{name: 'signup'}">프리미엄 구독하기</v-btn>
        </div>
      </section>

      <section v-else-if="!sorted_docs.length" class="empty-wrap">
        <div class="empty-contents-title">
          {{ $t('doc_list.empty_title') }}
        </div>
        <div class="empty-contents-meta">
          {{ $t('doc_list.empty_meta_1') }}
        </div>
        <div>
          <v-btn @click="showAddDocuments()"
            depressed rounded dark color="#536bff">
            <v-icon>mdi-plus</v-icon>
            <span>{{ $t('doc_list.add_documents') }}</span>
          </v-btn>
        </div>
      </section>

      <section v-else-if="!!search_keyword&&!filtered_docs.length" class="empty-wrap">
        <div class="empty-contents-title">찾으시는 결과가 없네요 😅</div>
        <div class="empty-contents-meta">다른 키워드를 사용해보시겠어요?</div>
      </section>

      <section id="content-table" v-else-if="!small_screen">
        <div id="table-header">
          <div class="table-row">
            <div class="row-checkbox">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn small icon v-on="on" @click="all_selected=!all_selected">
                    <v-icon color="#536bff" v-if="part_selected">mdi-minus-box</v-icon>
                    <v-icon color="#536bff" v-else-if="all_selected">mdi-checkbox-marked</v-icon>
                    <v-icon color="#c1c3c9" v-else>mdi-checkbox-blank-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('actions.select_all') }}</span>
              </v-tooltip>
            </div>
            <div class="row-title">
              {{ $t('doc_info.title') }}
            </div>
            <div class="row-authors">
              {{ $t('doc_info.authors') }}
            </div>
            <div class="row-date">
              {{ $t('doc_info.date') }}
            </div>
            <div class="row-review">
              {{ $t('doc_info.note') }}
            </div>
            <div class="row-tag">
              {{ $t('doc_info.tag') }}
            </div>
            <div class="row-menu">
            </div>
          </div>
        </div>
        <div class="table-content-wrap">
          <div class="table-content"
            v-for="(doc, index) in visible_docs" :key="index">
            <div class="table-row">
              <div class="row-checkbox">
                <v-btn small icon @click="checkDoc(doc.key)">
                  <v-icon color="#c1c3c9" class="checkbox-invisible" v-if="!checked_docs.includes(doc.key)">mdi-checkbox-blank-outline</v-icon>
                  <v-icon color="#536bff" v-else>mdi-checkbox-marked</v-icon>
                </v-btn>
              </div>
              <div class="row-title link-element" @click="selectDocument(doc.key)">
                <v-clamp autoresize :max-lines="1">
                  {{ doc.title }}
                </v-clamp>
              </div>
              <div class="row-authors">
                <v-clamp autoresize :max-lines="1">
                  {{ doc.authors_iso690 }}
                </v-clamp>
              </div>
              <div class="row-date">
                <v-clamp autoresize :max-lines="1">
                  {{ doc.date }}
                </v-clamp>
              </div>
              <div class="row-review">
                <v-icon small color="#ff9628" v-if="doc.has_note">mdi-note-multiple</v-icon>
              </div>
              <div class="row-tag">
                <v-menu offset-x>
                  <template v-slot:activator="{ on: { click } }">
                    <div v-on:click.stop.prevent="click">
                      <v-btn icon>
                        <v-icon small class="tag-visible" v-if="!!doc.tags" :color="doc.tags">mdi-tag</v-icon>
                        <v-icon small class="tag-invisible" v-else color="#bac2cc">mdi-tag-outline</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-list dense>
                    <v-list-item @click="setTags(doc.key, '')">
                      <div><v-icon small>mdi-tag-outline</v-icon></div>
                    </v-list-item>
                      <v-list-item v-for="(item, index) in project_tags" :key="index"
                        @click="setTags(doc.key, item)">
                        <div><v-icon small :style="{'color': item}">mdi-tag</v-icon></div>
                      </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="row-menu">
                <v-menu offset-y>
                  <template v-slot:activator="{ on: { click } }">
                    <div v-on:click.stop.prevent="click">
                      <v-btn small icon color="#c1c3c9">
                        <v-icon class="more" color="#bac2cc">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-list dense>
                    <v-list-item @click="temp_keys=[doc.key];copyDocuments()">
                      <div>다른 프로젝트로 복사/이동하기</div>
                    </v-list-item>
                    <v-list-item @click="temp_keys=[doc.key];remove_dialog=true">
                      <div>도큐먼트 클립에서 제거하기</div>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-else>
        <div class="card-wrap" v-for="(doc, index) in visible_docs" :key="index">
          <div class="card-header">
            <div class="row-checkbox">
              <v-btn small icon @click="checkDoc(doc.key)">
                <v-icon color="#c1c3c9" class="checkbox-invisible" v-if="!checked_docs.includes(doc.key)">mdi-checkbox-blank-outline</v-icon>
                <v-icon color="#536bff" v-else>mdi-checkbox-marked</v-icon>
              </v-btn>
            </div>
            <div class="card-tools">
              <div class="row-review">
                <v-icon small color="#ff9628" v-if="doc.has_note">mdi-note-multiple</v-icon>
              </div>
              <div class="row-tag">
                <v-menu offset-x>
                  <template v-slot:activator="{ on: { click } }">
                    <div v-on:click.stop.prevent="click">
                      <v-btn icon>
                        <v-icon small class="tag-visible" v-if="!!doc.tags" :color="doc.tags">mdi-tag</v-icon>
                        <v-icon small class="tag-invisible" v-else color="#bac2cc">mdi-tag-outline</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-list dense>
                    <v-list-item @click="setTags(doc.key, '')">
                      <div><v-icon small>mdi-tag-outline</v-icon></div>
                    </v-list-item>
                      <v-list-item v-for="(item, index) in project_tags" :key="index"
                        @click="setTags(doc.key, item)">
                        <div><v-icon small :style="{'color': item}">mdi-tag</v-icon></div>
                      </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="row-menu">
                <v-menu offset-y>
                  <template v-slot:activator="{ on: { click } }">
                    <div v-on:click.stop.prevent="click">
                      <v-btn small icon color="#c1c3c9">
                        <v-icon class="more" color="#bac2cc">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-list dense>
                    <v-list-item @click="temp_keys=[doc.key];copyDocuments()">
                      <div>다른 프로젝트로 복사/이동하기</div>
                    </v-list-item>
                    <v-list-item @click="temp_keys=[doc.key];remove_dialog=true">
                      <div>도큐먼트 클립에서 제거하기</div>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="card-contents">
            <div class="card-title link-element" @click="selectDocument(doc.key)">
              <v-clamp autoresize :max-lines="1">
                {{ doc.title }}
              </v-clamp>
            </div>
            <div class="card-meta">
              <div>
                <v-clamp autoresize :max-lines="1">
                  {{ doc.authors_iso690 }}
                </v-clamp>
              </div>
              <div>{{ doc.date }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Modals -->
    <modal-copy-documents
      :dialog.sync="copy_documents_visible"
      :projid="clip_id"
      :dockey="temp_keys">
    </modal-copy-documents>

    <modal-review-detail
      :dialog.sync="review_detail_visible"
      :dockey="detail_key">
    </modal-review-detail>

    <modal-expired-doc-clip
      :dialog.sync="expired_doc_clip_visible">
    </modal-expired-doc-clip>

    <!-- Remove Dialog -->
    <template>
      <v-dialog v-model="remove_dialog" width="400px">
        <v-card>
          <v-card-title>
            도큐먼트를 프로젝트에서 제거하시겠습니까?
          </v-card-title>
          <v-card-text>
            도큐먼트를 프로젝트에서 제거하더라도 <a href="/reviews" target="_blank">리뷰 페이지</a>에서 작성하신 도큐먼트 리뷰를 확인하실 수 있습니다.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="temp_keys=[];remove_dialog=false">
              {{ $t('actions.close') }}
            </v-btn>
            <v-btn small depressed color="primary"
              @click="removeDocuments()">
              {{ $t('doc_list.remove') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters, mapMutations } from 'vuex'
import { project_tags } from '../../../custom/model'
import { sortDocuments, returnDocDetail } from '../../../custom/function'

export default {
  metaInfo() {
    return {
      title: "Document-clip"
    }
  },

  components: {
    VClamp,
  },

  data() {
    return {
      project_tags,

      busy: false,
      clip: null,
      clip_id: null,

      sort_by: 0,
      sorted_docs: [],
      filtered_docs: [],
      visible_docs: [],
      
      checked_docs: [],
      all_selected: false,
      tag_selected: false,
      temp_keys: [],
      remove_dialog: false,

      num_docs: 0,
      num_pages: 0,
      index_page: 0,
      num_docs_page: 50,

      copy_documents_visible: false,
      review_detail_visible: false,

      search_keyword: '',
      screen_width: window.innerWidth,
    }
  },

  async created() {
    this.resize()
    window.addEventListener("resize", this.resize)
    try {
      if (!this.projects.filter(v => v.mode == 9).length) {
        await this.createDocumentClip()
      }
    } finally {
      this.clip = JSON.parse(JSON.stringify(this.projects.filter(v => v.mode == 9)[0]))
      this.clip_id = this.clip.proj_id
    }
    if (!this.expired) {
      // error handling
      this.busy = true
      await this.$store.dispatch('project/getProject', {
        proj_id: this.clip_id
      })
    } else {
      this.$router.replace({name: 'lab'})
    }
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  computed: {
    ...mapGetters({
      expired: 'auth/is_expired',
      expired_doc_clip_visible: 'modal/expired_doc_clip_visible',
      projects: 'project/projects',
      clip_info: 'project/project_info',
      clip_docs: 'project/documents',
    }),

    part_selected() {
      return this.checked_docs.length != this.visible_docs.length &&
        !!this.checked_docs.length
    },

    small_screen() {
      return this.screen_width < 800
    },

    detail_key() {
      return this.$route.query.doc
    },
  },

  watch: {
    clip_docs: {
      handler(val) {
        this.updateDocs(val, this.sort_by)
        this.checked_docs = []
      },
      deep: true,
    },

    sort_by(val) {
      this.updateDocs(this.sorted_docs, val)
    },

    all_selected(val) {
      if (val && this.checked_docs.length != this.visible_docs.length) {
        this.checked_docs = this.visible_docs.map(v => v.key)
      } else if (!val && !!this.checked_docs.length) {
        this.checked_docs = []
      }
    },

    tag_selected(val) {
      if (val) {
        this.filtered_docs = this.sorted_docs.filter(v => !!v.tags)
      } else {
        this.filtered_docs = this.sorted_docs
      }
    },

    checked_docs: {
      handler(val) {
        if (this.all_selected && !val.length) {
          this.all_selected = false
        } else if(!this.all_selected && val.length == this.visible_docs.length && !!val.length) {
          this.all_selected = true
        }
      },
      deep: true,
    },

    filtered_docs(val) {
      this.num_docs = val.length
      this.num_pages = Math.ceil(this.num_docs/this.num_docs_page)
      if (!!val.length && this.index_page>=this.num_pages) {
        this.index_page = 0
      }
      else { this.updateVisibleDocs() }
    },

    index_page(val) {
      this.updateVisibleDocs()
    },

    detail_key(val) {
      // console.log('detail_key', val)
      if (!!val) {
        this.review_detail_visible = true
      } else {
        this.initialize()
        this.review_detail_visible = false
      }
    },

    review_detail_visible: {
      handler(val) {
        // console.log('review_detail_visible', val)
        if (!val) {
          let to = { name: 'document-clip' }
          this.$router.push(to)
        }
      },
      immediate: false,
    },

    copy_documents_visible(val) {
      if (!val) { this.initialize() }
    },

    search_keyword: {
      handler(val) {
        if (!val || !val.length) {
          this.filtered_docs = this.sorted_docs
        } else {
          this.searchList(val)
        }
      },
    },

  },

  methods: {
    ...mapMutations({
      showAddDocumentsModal: 'modal/showAddDocuments',
      showExpiredDocClipModal: 'modal/showExpiredDocClip',
    }),

    sortDocuments,
    returnDocDetail,

    updateDocs(docs, sort_by) {
      let vm = this
      let new_docs = []
      if (!!docs.length) {
        docs.forEach(doc => {
          new_docs.push(vm.returnDocDetail(doc, doc.doc_type))
        })
        this.sorted_docs = this.sortDocuments(new_docs, parseInt(sort_by))
        if (this.tag_selected) {
          this.filtered_docs = this.sorted_docs.filter(v => !!v.tags)
        } else {
          this.filtered_docs = this.sorted_docs
        }
      } else {
        this.sorted_docs = []
        this.filtered_docs = []
      }
      this.busy = false
    },

    updateVisibleDocs() {
      this.initialize()
      this.visible_docs = 
        this.filtered_docs.slice(this.index_page*this.num_docs_page, (this.index_page+1)*this.num_docs_page)
    },

    initialize() {
      // console.log('initialize')
      this.temp_keys = []
      this.all_selected = false
      this.checked_docs = []
    },

    showAddDocuments() {
      this.showAddDocumentsModal()
      this.$analytics.logEvent('click', { name: 'project_btn_openAddDocuments' })
    },

    async createDocumentClip() {
      // TODO: error handling
      await this.$store.dispatch('project/createProject', {
        title: "Document Clip",
        mode: 9,
      })
    },

    checkDoc(key) {
      if (this.checked_docs.includes(key)) {
        let remove_index = this.checked_docs.indexOf(key)
        if (remove_index !== -1) {
          this.checked_docs.splice(remove_index, 1)
        }
      } else {
        this.checked_docs.push(key)
      }
    },

    copyDocuments() {
      this.copy_documents_visible = true
    },

    async removeDocuments() {
      try {
        await this.$store.dispatch('project/removeDocumentsFromProject', {
          proj_id: this.clip_id,
          documents: this.temp_keys,
        })
      } finally {
        this.initialize()
        this.remove_dialog = false
      }
    },

    async setTags(key, tags) {
      let index = this.sorted_docs.findIndex(obj => obj.key == key)
      this.sorted_docs[index].tags = tags
      // TODO: error handling
      await this.$store.dispatch('project/setStar', {
        proj_id: this.clip_id,
        doc_key: key,
        tags: tags
      })
    },

    searchList(keyword) {
      keyword = keyword.toLowerCase()
      this.filtered_docs = this.sorted_docs.filter(v => {
        return v.authors_iso690.toLowerCase().includes(keyword) ||
        (!!v.date && v.date.toLowerCase().includes(keyword)) ||
        v.title.toLowerCase().includes(keyword)
      })
    },

    resize() {
      this.screen_width = window.innerWidth
    },

    selectDocument(key) {
      // console.log('select document', key)
      let to = { name: 'document-clip', query: { doc: key }}
      this.$router.push(to)
    },
  },
}
</script>

<style scoped>
  #wrap-document-clip {
    width: 100%;
    padding: 20px 40px;
  }

  /* Header */

  #header-document-clip {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #header-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #title-document-clip {
    font-size: 16px;
    font-weight: 600;
    color: #323334;
  }

  #btn-add-documents {
    margin-left: 12px;
  }

  /* Content toolbar */

  #content-toolbar {
    margin: 12px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #toolbar-left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #toolbar-right {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #858d97;
  }

  #toolbar-right div {
    margin-left: 12px;
  }

  /* Contents table */

  #content-table {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
  }

  #table-header {
    border-top: solid 1px #dde2e5;
    border-bottom: solid 1px #dde2e5;
    background-color: #f3f4f6;
    color: #485158;
    font-size: 14px;
    font-weight: bolder;
    height: 46px;
  }

  .table-content-wrap {
    background-color: white;
  }

  .table-content .table-row {
    height: 50px;
    color: #485158;
    font-size: 13px;
    border-bottom: 1px solid #dde2e5;
  }

  .table-row:hover {
    background-color: #fafafb;
  }

  .table-row {
    display: grid;
    grid-template-columns: 7% 50% 15% 10% 7% 7% 4%;
    height: 100%;
  }

  .table-row > div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
  }

  /* .table-row .tag-invisible, .table-row .more, .table-row .checkbox-invisible {
    visibility: hidden;
  } */

  /* .table-row:hover .tag-invisible, .table-row:hover .more, .table-row:hover .checkbox-invisible {
    visibility: visible;
  } */

  /* Empty */

  .empty-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
  }

  .empty-contents-title {
    font-size: 20px;
    padding-bottom: 20px;
  }

  .empty-contents-meta {
    font-size: 14px;
    padding-bottom: 20px;
    color: rgb(0, 0, 0, .4);
  }

  .card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .card-tools {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #485158;
  }

  .card-meta {
    display: grid;
    grid-template-columns: 50% 50%;
  }

  .card-meta > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .card-wrap {
    border: 1px solid #dde2e5;
    background-color: white;
    margin-bottom: 20px;
  }

  .card-wrap:hover {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  .card-header {
    padding: 12px 12px 0 12px;
  }

  .card-contents {
    padding: 0 12px 12px 12px;
  }

  .expired-contents-meta {
    font-size: 14px;
    padding-top: 20px;
    text-align: center;
  }

  .expired-contents-btn {
    margin-top: 20px;
    text-align: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/lab/Document-clip.vue